import { TOGGLE_MODAL, SET_RETURN_FOCUS } from "../../actions/Modal";

const initialState = {
  termsAndConditionsModalVisible: false,
  returnFocus: null,
};

const Modal = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_MODAL: {
      return Object.assign({}, state, {
        termsAndConditionsModalVisible: !state.termsAndConditionsModalVisible,
        returnFocus: state.returnFocus,
        termsUrl: action.termsUrl,
      });
    }
    case SET_RETURN_FOCUS: {
      return Object.assign({}, state, {
        returnFocus: action.returnFocus,
      });
    }
    default: {
      return state;
    }
  }
};

export default Modal;
